<template>
  <el-dialog
    class="one-click-price"
    width="1800px"
    title="一键定价"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="dialogClose"
  >
    <template #title>
      <div class="dialog-title-box">
        <span class="title">一键定价</span>
        <div class="freight-box">
          <el-input v-model="all_freight_value" clearable></el-input>
          <el-button type="primary" @click="setFreightAll">批量设置运费</el-button>
        </div>
      </div>
    </template>
    <el-row class="mb10" type="flex" justify="space-between" align="middle">
      <el-col :span="7">
        <el-input
          size="mini"
          placeholder="0.00"
          v-model="formData.purchasePrice"
          @change="handleInputValue('purchasePrice')"
          @blur="setOneClickPriceAll"
          @input="oneClickPrice"
        >
          <template slot="prepend">采购单价</template>
          <template slot="append">¥</template>
        </el-input>
      </el-col>
      <el-col :span="7">
        <el-input
          size="mini"
          placeholder="0.00"
          v-model="formData.domesticFreight"
          @change="handleInputValue('domesticFreight')"
        >
          <template slot="prepend">国内运费</template>
          <template slot="append">¥</template>
        </el-input>
      </el-col>
      <el-col :span="7">
        <el-input
          size="mini"
          placeholder="0.00"
          v-model="formData.weight"
          @change="handleInputValue('weight')"
        >
          <template slot="prepend">产品重量</template>
          <template slot="append">Kg</template>
        </el-input>
      </el-col>
    </el-row>
    <el-row class="mb10" type="flex" justify="space-between" align="middle">
      <el-col :span="6">
        <el-input
          size="mini"
          placeholder="0"
          v-model="formData.length"
          @change="handleInputValue('length')"
        >
          <template slot="prepend">长</template>
          <template slot="append">cm</template>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          size="mini"
          placeholder="0"
          v-model="formData.width"
          @change="handleInputValue('width')"
        >
          <template slot="prepend">宽</template>
          <template slot="append">cm</template>
        </el-input>
      </el-col>
      <el-col :span="6">
        <el-input
          size="mini"
          placeholder="0"
          v-model="formData.height"
          @change="handleInputValue('height')"
        >
          <template slot="prepend">高</template>
          <template slot="append">cm</template>
        </el-input>
      </el-col>
      <div>
        <el-button type="primary" size="mini" @click="oneClickPrice">系统一键定价</el-button>
        <el-button type="primary" size="mini" @click="openSafetyFactor">安全系数</el-button>
      </div>
    </el-row>

    <table class="table-box" border="0" cellpadding="0" cellspacing="0" width="1760px">
      <thead>
        <tr>
          <th></th>
          <th v-for="(item, index) in countryList" :key="index">
            <span :style="{ color: item.isAbnormal ? 'red' : '' }">{{ item.name }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td width="120">运费/¥</td>
          <td v-for="(item, index) in tableData" :key="index">
            <el-input size="mini" v-model="item.freight" @change="setOneClickPrice(item)"></el-input>
          </td>
        </tr>
        <tr>
          <td width="120">成本价/¥</td>
          <td v-for="(item, index) in tableData" :key="index">{{ item.cost }}</td>
        </tr>
        <tr>
          <td width="120">利润百分比/%</td>
          <td v-for="(item, index) in tableData" :key="index">
            <el-input-number
              style="width: 100%;"
              size="mini"
              v-model="item.profitPercentage"
              controls-position="right"
              :min="0"
              :max="84"
              @change="setProfitPercentage(item)"
            ></el-input-number>
          </td>
        </tr>
        <tr>
          <td width="120">汇率</td>
          <td v-for="(item, index) in tableData" :key="index">{{ item.exchangeRate }}</td>
        </tr>
        <tr>
          <td width="120">结果价格/¥</td>
          <td v-for="(item, index) in tableData" :key="index">{{ item.resultPrice }}</td>
        </tr>
        <tr>
          <td width="120">
            <span class="custom-color" @click="openPriceOptimizeDialog">价格优化(当地价)</span>
          </td>
          <td
            v-for="(item, index) in tableData"
            :key="index"
          >{{ item.priceOptimize }} {{ `[${item.currency}]` }}</td>
        </tr>
        <tr>
          <td width="120">最终定价(当地价)</td>
          <td v-for="(item, index) in tableData" :key="index">
            <el-input size="mini" v-model="item.finalPrice"></el-input>
          </td>
        </tr>
        <tr>
          <td width="120">利润(￥)</td>
          <td v-for="(item, index) in tableData" :key="index">{{ item.profit }}</td>
        </tr>
      </tbody>
    </table>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="confirmOneClickPrice">确 定</el-button>
    </div>

    <el-dialog
      width="30%"
      title="修改价格优化"
      :visible.sync="dialogPriceOptimizeVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form inline>
        <el-form-item label="价格优化">
          <el-input v-model="priceOptimizeValue"></el-input>
        </el-form-item>
        <el-form-item label="推荐价格优化">
          <span
            style="padding: 0 15px;cursor: pointer;"
            v-for="(item, index) in listPriceOptimize"
            :key="index"
            @click="priceOptimizeClick(item)"
          >{{ item }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogPriceOptimizeVisible = false">取 消</el-button>
        <el-button type="primary" @click="priceOptimizeConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      width="30%"
      title="安全系数"
      :visible.sync="dialogSafetyFactorVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form inline label-width="80px">
        <template v-for="item in countryList">
          <el-form-item :label="item.name" :key="item.value">
            <!-- <el-input v-model="listSafetyFactor[item.value]"></el-input> -->
            <el-row type="flex" align="middle">
              <el-input-number
                v-model="listSafetyFactor[item.value]"
                controls-position="right"
                :min="1"
                size="mini"
              ></el-input-number>
              <div style="padding: 0 10px;">%</div>
            </el-row>
          </el-form-item>
        </template>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogSafetyFactorVisible = false">取 消</el-button>
        <el-button type="primary" @click="safetyFactorConfirm">确 定</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>
<script>
import Big from 'big.js'

import FreightCalculation from './FreightCalculation'

import { CountryList, ProfitPercentage, SafetyFactor } from './CountryList.js'

// 利润百分比
let profitPercentage = ProfitPercentage

export default {
  name: "OneClickPrice",
  props: {
    exchangeRateList: {
      type: Array,
      default() {
        return [];
      },
    },
    productPricePojo: {
      type: Object,
      default() {
        return {
          productHeight: '',
          productLenght: '',
          productUnitPrice: '',
          productWeight: '',
          productWidth: '',
        };
      },
    },
    productPriceObject: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  data() {
    return {
      productPriceData: {},
      dialogVisible: false,
      countryList: Object.freeze(CountryList),
      formData: {
        id: '',
        purchasePrice: '',
        domesticFreight: '0',
        weight: '1',
        length: '1',
        width: '1',
        height: '1'
      },
      tableData: [],
      dialogPriceOptimizeVisible: false,
      priceOptimizeValue: '99',
      listPriceOptimize: ["21", "43", "45", "56", "99"],

      dialogSafetyFactorVisible: false,
      listSafetyFactor: SafetyFactor,
      all_freight_value: '',
    };
  },
  watch: {
    productPricePojo: {
      handler(newVal) {
        // console.log(newVal)
        if (Object.prototype.toString.call(newVal) !== '[object Object]') return
        if (newVal.id) this.formData.id = newVal.id
        if (newVal.productHeight) this.formData.height = newVal.productHeight
        if (newVal.productLenght) this.formData.length = newVal.productLenght
        if (newVal.productWeight) this.formData.weight = newVal.productWeight
        if (newVal.productWidth) this.formData.width = newVal.productWidth
        if (newVal.productUnitPrice) this.formData.purchasePrice = newVal.productUnitPrice
      },
      // immediate: true
    }
  },
  computed: {
    exchangeRateData() {
      const tempObj = {};
      this.exchangeRateList.forEach(item => (tempObj[item.currencyCode] = item.exchangeRate));
      return tempObj;
    },
  },
  methods: {
    // 批量设置运费
    setFreightAll(){
      const val = Number(this.all_freight_value);
      if (this.all_freight_value === '' || this.all_freight_value === null || isNaN(val)) {
        this.$message.warning('请输入有效的运费');
        return;
      }

      this.tableData.forEach(item => {
        item.freight = val;
        this.setOneClickPrice(item);
      });
    },
    dialogOpen() {
      this.dialogVisible = true;
      this.setTableData();
      this.setCountryPrice();
      this.countryList.forEach(item => (item.isAbnormal = false));
    },
    dialogClose() { },
    setTableData() {
      // 从本地拿 价格优化 数据，有就覆盖，没有就写入本地
      const tempValue = localStorage.getItem("PriceOptimize");
      if (tempValue) {
        this.priceOptimizeValue = tempValue;
      } else {
        localStorage.setItem("PriceOptimize", this.priceOptimizeValue);
      }
      // 从本地拿 安全系数 数据，有就覆盖，没有就写入本地
      const tempObj = localStorage.getItem("SafetyFactor");
      if (tempObj) {
        this.listSafetyFactor = JSON.parse(tempObj);
      } else {
        const SafetyFactor = JSON.stringify(this.listSafetyFactor);
        localStorage.setItem("SafetyFactor", SafetyFactor);
      }

      // 从本地拿 利润百分比 数据，有就覆盖，没有就写入本地
      const localProfitPercentage = localStorage.getItem("ProfitPercentage");
      if (localProfitPercentage) {
        profitPercentage = JSON.parse(localProfitPercentage);
      } else {
        localStorage.setItem("ProfitPercentage", JSON.stringify(profitPercentage));
      }
      if (this.tableData.length) return
      // 处理表格中的数据
      CountryList.forEach(item => {
        const { name: countryName, currency, value: countryTag } = item
        const temporaryObj = {
          freight: '',
          cost: '',
          profitPercentage: profitPercentage[countryTag] || '50',
          exchangeRate: this.exchangeRateData[currency],
          resultPrice: '',
          priceOptimize: '',
          finalPrice: '',
          profit: '',
          countryTag,
          countryName,
          currency
        }
        this.tableData.push(temporaryObj)
      })
      if (this.formData.purchasePrice) this.oneClickPrice()
      this.setCountryPrice()
    },
    handleInputValue(key) {
      this.formData[key] = this.formData[key].replace(/[a-zA-Z\s]/g, '')
    },
    setProfitPercentage(item) {
      profitPercentage[item.countryTag] = item.profitPercentage
      localStorage.setItem("ProfitPercentage", JSON.stringify(profitPercentage));
      this.setOneClickPrice(item)
    },
    setOneClickPriceAll() {
      this.tableData.forEach(item => {
        this.setOneClickPrice(item)
      })
    },
    setOneClickPrice(item) {
      if (!item.freight || !this.formData.purchasePrice) return
      try {
        const { currency } = item
        item.cost = new Big(item.freight).plus(this.formData.purchasePrice).plus(this.formData.domesticFreight).toNumber().toFixed(2)
        item.resultPrice = new Big(item.cost).div((new Big(85).minus(item.profitPercentage)).div(100)).toNumber().toFixed(2)
        item.priceOptimize = new Big(item.resultPrice).div(this.exchangeRateData[currency]).toNumber().toFixed(2);
        //  + `.${this.priceOptimizeValue}`
        item.finalPrice = item.priceOptimize
        const tempProfit = new Big(item.resultPrice).minus(item.cost).toNumber().toFixed(2)
        item.profit = `${tempProfit}(${new Big(tempProfit).div(item.resultPrice).times(100).minus(15).toNumber().toFixed(0)}%)`
        if (Number(item.freight) === 0) {
          const itemCountry = this.countryList.find(key => key.currency === currency);
          itemCountry.isAbnormal = true
        }
        if(item.countryTag === "JP" || item.countryTag === "IN"){
          item.finalPrice = Math.round(item.finalPrice ? +item.finalPrice : 0);
          item.priceOptimize = Math.round(item.priceOptimize ? +item.priceOptimize : 0);
        }
      } catch (error) {
        console.log(error);
      }
    },
    oneClickPrice() {
      for (let key in this.formData) {
        if (key === 'id') continue
        if (this.formData[key] !== 0 && this.formData[key] === '') {
          this.$message.warning('请将信息填写完整后再一键定价！')
          return
        }
      }
      this.countryList.forEach(key => key.isAbnormal = false);
      let calculation = null
      calculation = new FreightCalculation(this.formData)

      this.tableData.forEach(item => {
        const { countryTag } = item
        const freightValue = calculation.getCalculationValue(countryTag) // 未乘安全系数之前的运费
        item.freight = freightValue + '' // item.freight保存字符串，在setOneClickPrice方法中需要做判断

        if (Number(item.freight) !== 0) {
          item.freight = new Big(item.freight).times(new Big(this.listSafetyFactor[countryTag]).div(100)).toNumber() + ''
        }
        this.setOneClickPrice(item)
      })
    },
    openPriceOptimizeDialog() {
      this.dialogPriceOptimizeVisible = true
    },
    priceOptimizeClick(item) {
      this.priceOptimizeValue = item;
      localStorage.setItem("PriceOptimize", this.priceOptimizeValue);
    },
    priceOptimizeConfirm(item) {
      this.dialogPriceOptimizeVisible = false
      this.setOneClickPriceAll(item)
    },
    openSafetyFactor() {
      this.dialogSafetyFactorVisible = true
    },
    safetyFactorConfirm() {
      this.dialogSafetyFactorVisible = false
      const SafetyFactor = JSON.stringify(this.listSafetyFactor);
      localStorage.setItem("SafetyFactor", SafetyFactor);
      this.oneClickPrice()
    },
    setCountryPrice() {
      this.$nextTick(()=>{
        let d = this.productPriceObject;
        if (!Object.keys(d).length) return
        this.tableData.forEach(item => {
          this.$set(item, 'finalPrice', d[item.countryTag].value)
          // item.finalPrice = this.productPriceObject[item.countryTag].value
        })
      })
    },
    confirmOneClickPrice() {
      for (const item of this.tableData) {
        if (item.finalPrice === '') {
          this.$message.warning("请先系统一键定价");
          return;
        }
      }
      const tipsStatus = this.tableData.some(item => Number(item.freight) === 0)

      const handleFn = () => {
        const priceObj = {}
        this.tableData.forEach(item => {
          priceObj[item.countryTag] = {
            value: item.finalPrice,
            currency: item.currency
          }
        })
        const tempObjGB = this.tableData.find(item => item.countryTag === 'GB')
        priceObj.ZH = {
          value: tempObjGB.resultPrice,
          currency: 'CNY'
        }
        console.log(priceObj);
        this.$emit("confirm", priceObj);
        this.$emit("setMoneyInfo", {
          productUnitPrice: this.formData.purchasePrice,
          productWeight: this.formData.weight,
          productLenght: this.formData.length,
          productWidth: this.formData.width,
          productHeight: this.formData.height,
          id: this.formData.id
        });
        this.dialogVisible = false
      }; 
      if (tipsStatus) {
        this.$confirm("定价存在异常，是否确认定价？", "提示").then(() => {
          handleFn();
        }).catch(() => { })
      } else {
        handleFn();
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.one-click-price {
  .mb10 {
    margin-bottom: 10px;
  }
  .table-box {
    border-collapse: collapse;
  }
  td,
  th {
    text-align: center;
    line-height: 36px;
    border: 1px solid #ebeef5;
  }
  .custom-color {
    color: #3a8ee6;
    cursor: pointer;
  }
}
.dialog-title-box{
  display: flex;
  align-items: center;
  .title{
    font-size: 18px;
  }
  .freight-box{
    display: flex;
    align-items: center;
    margin-left: 20px;
  }
}
</style>
